import { connectSortBy } from 'instantsearch.js/es/connectors'

const renderSortBy = (renderOptions, isFirstRender) => {
  const {
    options,
    refine,
    widgetParams,
  } = renderOptions

  if (isFirstRender) {
    widgetParams.container.innerHTML = `
    <label class="switch-filter">
      <input class="switch-filter__input" type="checkbox" checked>
      <span class="emphasis switch-filter__past">${config.trads['list.event.past']}</span>
      <span class="switch-filter__switch"></span>
      <span class="emphasis switch-filter__upcoming">${config.trads['list.event.upcoming']}</span>
    </label>`
  } else {
    const input = widgetParams.container.querySelector('input')

    input.addEventListener('change', e => {
      if (e.target.checked) {
        refine(options[0].value)
      } else {
        refine(options[1].value)
      }

      widgetParams.searchInstance.renderState[widgetParams.indexName].configure.refine({
        hitsPerPage: 12,
        filters: e.target.checked
          ? `timestampEndDate >= ${Date.now() / 1000} AND status:published AND locale:${config.locale} AND type:event`
          : `timestampEndDate < ${Date.now() / 1000} AND status:published AND locale:${config.locale} AND type:event`,
      })
    })
  }
}

const customSortEvent = connectSortBy(renderSortBy)

export default customSortEvent
